import React from 'react';
import { GridToolbarContainer } from '@mui/x-data-grid';

const EmptyTableToolbar = () => {
  return <GridToolbarContainer></GridToolbarContainer>;
};

export default EmptyTableToolbar;
